<template>
  <!-- The legacy "Our Values" copy and icons (views/about/Sections/GoalSection.vue) in the current
       layout: a pale blue band, centred heading and description, and each value as its icon beside
       its heading (first word in DIGU Blue) and text, two per row. -->
  <sec-section :divider="false" labelledby="about-values" class="about-values">
    <sec-section-heading id="about-values" :title="values.title" :lede="values.lede" />
    <ul class="about-values__grid">
      <li v-for="item in values.items" :key="item.accent" class="about-values__item" data-reveal>
        <span class="about-values__icon" aria-hidden="true">
          <img :src="item.icon" alt="" width="34" height="34" />
        </span>
        <div class="about-values__content">
          <h3 class="o600 about-values__heading">
            <span class="about-values__accent">{{ item.accent }}</span>{{ item.rest }}
          </h3>
          <p class="m500 about-values__text">{{ item.text }}</p>
        </div>
      </li>
    </ul>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import { ABOUT } from '@/content/security/about';

const values = ABOUT.values;
</script>

<style scoped>
.about-values {
  background: var(--sec-accent-subtle);
}

.about-values__grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sec-s2);
}

.about-values__item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 0.75rem;
  border-radius: 16px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.about-values__item:hover {
  background: var(--sec-surface);
  box-shadow: 0 18px 36px -24px var(--sec-header-shadow);
}

.about-values__icon {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--sec-surface);
  color: var(--sec-accent-text);
  box-shadow: 0 0 0 1px var(--sec-line);
  transition: box-shadow 0.3s ease;
}

.about-values__icon img {
  display: block;
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.about-values__item:hover .about-values__icon {
  box-shadow: 0 0 0 2px var(--sec-accent);
}

.about-values__content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
  text-align: left;
}

.about-values__heading {
  margin: 0;
  font-size: 1.375rem;
  line-height: 1.25;
  color: var(--sec-ink);
}

/* DIGU Blue, the logo colour (legacy .colored-text used --primary-color). */
.about-values__accent {
  color: var(--sec-accent);
}

.about-values__text {
  font-size: 1.0625rem;
  line-height: 1.6;
  color: var(--sec-ink-2);
}

@media only screen and (min-width: 768px) {
  .about-values__item {
    gap: 1.25rem;
    padding: 1.5rem;
  }
  .about-values__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--sec-s2) var(--sec-s4);
  }
}

@media only screen and (min-width: 992px) {
  .about-values__item {
    padding: 2rem;
  }
  .about-values__heading {
    font-size: 1.625rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .about-values__item,
  .about-values__icon {
    transition: none;
  }
}
</style>
